import { principles, stats, testimonials, brandName } from "@/mocks/guaContent";

export default function About() {
  return (
    <section id="about" className="relative bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <p className="text-sm font-semibold text-primary-600 tracking-wide">ABOUT · 关于口碑</p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900 leading-snug">
              认真做一件「轻松吃瓜」的小事
            </h2>
            <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
              {brandName}诞生的初衷很简单：信息越吵，越需要有人帮你把瓜理清楚。
              我们不做标题党、不抢首发、不贩卖焦虑，只做一件事——把当天的热点整理成
              干净、可信、有观点的瓜报，按时送到你的邮箱。
            </p>
            <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {principles.map((pr) => (
                <div key={pr.title} className="rounded-lg bg-background-50 border border-background-200 p-4">
                  <i className={"text-2xl text-primary-600 " + pr.icon}></i>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-900">{pr.title}</h3>
                  <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{pr.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-accent-100/60 border border-accent-200 p-6 text-center">
                <p className="font-heading text-3xl md:text-4xl font-black text-accent-700">{s.num}</p>
                <p className="mt-2 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-14">
          <div className="flex items-center gap-3">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">读者怎么说</h3>
            <div className="flex items-center gap-1 text-secondary-500">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-half-fill"></i>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-5">
                <i className="ri-double-quotes-l text-2xl text-secondary-400"></i>
                <blockquote className="mt-2 flex-1 text-sm text-foreground-700 leading-relaxed">
                  {t.text}
                </blockquote>
                <figcaption className="mt-4 border-t border-background-200 pt-3">
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.tag}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}